import moment from 'moment';

/**
 * Tasks come with a type representing the type of alert that has created the task,
 * this func. normalizes the naming including type for manual tasks which come with a type
 * of null.
 * @param taskType
 * @returns {String}
 */
export function formatTaskType(taskType) {
  if (!taskType) return 'MANUAL';
  if (taskType.includes('TASK_TYPE_MANAGE')) return taskType.replace('TASK_TYPE_MANAGE_', '');
  if (taskType.includes('TASK_TYPE')) return taskType.replace('TASK_TYPE_', '');
}

/**
 * @param hours {Number}
 * @param days {Number}
 * @param minutes {Number}
 * @returns {string}
 */
export function formatTime({ hours, days, minutes }) {
  const times = {
    dayAndHours: (days, hours) => `${days}d ${hours || 1}h`,
    hoursAndMinutes: (hours, minutes) => `${hours}h ${minutes || 1}min`,
    minutes: (minutes) => `${minutes || 1}min`,
  };

  if (days) return times.dayAndHours(days, hours);
  if (hours) return times.hoursAndMinutes(hours, minutes);
  return times.minutes(minutes);
}

/**
 * @param from {string}
 * @param to {string}
 * @returns {{hours: Number, minutes: Number, days: Number}}
 */
export function getDuration({ from, to }) {
  const timeDifference = moment.duration(moment(to).diff(moment(from)));

  return roundMinutes({
    days: timeDifference.days(),
    hours: timeDifference.hours(),
    minutes: timeDifference.minutes(),
  });
}

/**
 * @param hours {Number}
 * @param days {Number}
 * @param minutes {Number}
 * @returns {{hours: Number, minutes: Number, days: Number}}
 */
export function roundMinutes({ days, hours, minutes }) {
  const minutesRounded = Math.ceil(minutes / 5) * 5;

  return {
    days: days,
    hours: hours + (minutesRounded >= 60 ? 1 : 0),
    minutes: minutesRounded >= 60 ? 0 : minutesRounded,
  };
}
